"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var networker_1 = require("@idp/networker");
var idpCartInit = 'idpCartInitialized';
var sid = 'sessionId';
var keepSessionAliveApiUrlEds = '/msapi/referrals/v1/sessionKeepAlive';
var csrfApi = '/msapi/id';
var isCsrfToken = {
    value: '',
};
var thisPointer;
var isSessionNameSpace = 'appShell:csrf-token';
var newSidVal;
var InitializeCart = /** @class */ (function () {
    function InitializeCart() {
        this.initializeCartApiUrl = '/msapi/cart/v1/intializeCart';
        this.uuidval = '';
        this.isRetrieveCart = false;
        this.headers = [
            {
                name: 'Accept-Language',
                value: 'en-US,en;q=0.9',
            },
            {
                name: 'Content-Type',
                value: 'application/json',
            },
        ];
        this.initializeCartApi = this.initializeCartApi.bind(this);
        this.initializeCartWithAddlQueryParam = this.initializeCartWithAddlQueryParam.bind(this);
        this.networker = new networker_1.Networker();
        thisPointer = this;
    }
    InitializeCart.prototype.initializeCartApi = function (sessionNameSpace, sidVal, qryParam) {
        return __awaiter(this, void 0, void 0, function () {
            var url, queryParam, parmaArry, _i, parmaArry_1, checkuuid, uuidArry;
            return __generator(this, function (_a) {
                csrfApi = '/msapi/id';
                this.isRetrieveCart = false;
                this.uuidval = '';
                url = location.href;
                queryParam = url.split('?')[1];
                isSessionNameSpace = sessionNameSpace;
                newSidVal = sidVal || '';
                if (qryParam) {
                    this.initializeCartApiUrl = this.initializeCartApiUrl + '?' + qryParam;
                }
                if (queryParam) {
                    parmaArry = queryParam.split('&');
                    if ((parmaArry.includes('retrievecart=true') || parmaArry.includes('retrieveCart=true'))) {
                        this.isRetrieveCart = true;
                        for (_i = 0, parmaArry_1 = parmaArry; _i < parmaArry_1.length; _i++) {
                            checkuuid = parmaArry_1[_i];
                            if ((/uuid/i).test(checkuuid)) {
                                uuidArry = checkuuid.split('=');
                                this.uuidval = uuidArry[1];
                                csrfApi = csrfApi + '?uuid=' + this.uuidval;
                            }
                        }
                    }
                }
                return [2 /*return*/, thisPointer.checkCsrfApi()];
            });
        });
    };
    /*
     * Make sure this function is called only after csrf token is generated. Else it will not work.
     * if it is invoked before that, then the bug is on you do not blame it on to this function
     */
    InitializeCart.prototype.initializeCartWithAddlQueryParam = function (qryParam, nameSpace) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (nameSpace) {
                    isSessionNameSpace = nameSpace;
                }
                this.isRetrieveCart = true;
                this.initializeCartApiUrl = this.initializeCartApiUrl + '?' + qryParam;
                return [2 /*return*/, thisPointer.checkCsrfApi()];
            });
        });
    };
    // New code 'idpCartInitialized' share with legacy code
    InitializeCart.prototype.isIdpCartInitialized = function () {
        var persistentCartInfo = sessionStorage.getItem(idpCartInit);
        var oldSidVal = sessionStorage.getItem(sid);
        if (!persistentCartInfo || persistentCartInfo !== 'true') {
            thisPointer.setSidInSession(newSidVal);
            return false;
        }
        else if (oldSidVal !== null && oldSidVal !== undefined && oldSidVal !== '' &&
            newSidVal !== null && newSidVal !== undefined && newSidVal !== '' &&
            (oldSidVal !== newSidVal)) {
            var selectedDeviceConfigObj = sessionStorage.getItem('selectedDeviceConfig');
            var idseFlowSelectedObjObj = sessionStorage.getItem('WIRELESS:IDSEFlowSelected');
            var partnerAttributesObj = sessionStorage.getItem('partnerAttributes');
            var partnerObj = sessionStorage.getItem('partner');
            console.log('Before clearing session');
            console.log('Partner:' + JSON.stringify(partnerAttributesObj));
            sessionStorage.clear();
            thisPointer.setSidInSession(newSidVal);
            if (selectedDeviceConfigObj) {
                sessionStorage.setItem('selectedDeviceConfig', JSON.stringify(selectedDeviceConfigObj));
            }
            if (idseFlowSelectedObjObj) {
                sessionStorage.setItem('WIRELESS:IDSEFlowSelected', JSON.stringify(idseFlowSelectedObjObj));
            }
            if (partnerAttributesObj) {
                sessionStorage.setItem('partnerAttributes', JSON.parse(JSON.stringify(partnerAttributesObj)));
            }
            if (partnerObj) {
                sessionStorage.setItem('partner', JSON.parse(JSON.stringify(partnerObj)));
            }
            return false;
        }
        else {
            thisPointer.setSidInSession(newSidVal);
            return true;
        }
    };
    InitializeCart.prototype.setIdpCartInitialized = function () {
        sessionStorage.setItem(idpCartInit, 'true');
    };
    InitializeCart.prototype.rejectHTTPErrors = function (res) {
        return (res.status >= 400) ? res.json().then(Promise.reject.bind(Promise)) : Promise.resolve(res);
    };
    InitializeCart.prototype.getInitialHeaders = function () {
        var defaultHeaders = new Headers();
        thisPointer.headers.forEach(function (header) {
            defaultHeaders.append(header.name, header.value);
        });
        isCsrfToken = thisPointer.getCsrfValFromSession();
        if (isCsrfToken && isCsrfToken.value) {
            defaultHeaders.append('X-CSRF-TOKEN', isCsrfToken.value);
        }
        return defaultHeaders;
    };
    InitializeCart.prototype.getCsrfValFromSession = function () {
        var value = sessionStorage.getItem(isSessionNameSpace);
        isCsrfToken = value ? JSON.parse(value) : null;
        return isCsrfToken;
    };
    InitializeCart.prototype.checkCsrfApi = function () {
        isCsrfToken = thisPointer.getCsrfValFromSession();
        if (isCsrfToken && isCsrfToken.value && newSidVal) {
            return thisPointer.isApiCallRequired();
        }
        else {
            return this.networker.get(csrfApi, { headers: thisPointer.getInitialHeaders() })
                .then(this.rejectHTTPErrors)
                .then(function (res) {
                var token = { value: res.headers.get('X-CSRF-TOKEN') };
                var sessionId = { value: res.headers.get('sid') };
                if (sessionId && sessionId.value) {
                    newSidVal = String(sessionId.value);
                    sessionStorage.setItem('appShell:sid', JSON.stringify(sessionId));
                }
                if (token.value !== null && isSessionNameSpace) {
                    sessionStorage.setItem(isSessionNameSpace, JSON.stringify(token));
                }
                return thisPointer.isApiCallRequired();
            })
                .catch(function (err) {
                return Promise.reject(err);
            });
        }
    };
    InitializeCart.prototype.callIntializeCartApi = function () {
        return this.networker.get(this.initializeCartApiUrl, { headers: thisPointer.getInitialHeaders() })
            .then(this.rejectHTTPErrors)
            .then(function (res) {
            if (res && res.error && res.error.errorId === 'Cart-Initialization-Redirection-1001') {
                var flowType = 'UP';
                if (res.error && res.error.details && res.error.details[0] && res.error.details[0].message) {
                    flowType = res.error.details[0].message;
                }
                if (window && window.location && window.location.origin) {
                    window.location.href = window.location.origin + '/buy/wireless?wlsfi=' + flowType;
                }
            }
            else {
                thisPointer.setIdpCartInitialized();
            }
            return Promise.resolve(res);
        })
            .catch(function (err) {
            thisPointer.setIdpCartInitialized();
            return Promise.reject(err);
        });
    };
    InitializeCart.prototype.setSidInSession = function (newVal) {
        if (newVal && newVal !== null && newVal !== undefined && newVal.length > 1) {
            sessionStorage.setItem(sid, newVal);
        }
    };
    InitializeCart.prototype.callKeepSessionKeepAliveEds = function () {
        return this.networker.get(keepSessionAliveApiUrlEds, { headers: thisPointer.getInitialHeaders() })
            .then(this.rejectHTTPErrors)
            .then(function (res) {
            return Promise.resolve(res);
        })
            .catch(function (err) {
            return Promise.reject(err);
        });
    };
    InitializeCart.prototype.concurrentApiCall = function () {
        return thisPointer.callIntializeCartApi();
    };
    InitializeCart.prototype.isApiCallRequired = function () {
        if (this.isRetrieveCart || !thisPointer.isIdpCartInitialized()) {
            return thisPointer.concurrentApiCall();
        }
        else {
            return Promise.resolve({ content: { status: 'api calls not required' } });
        }
    };
    return InitializeCart;
}());
exports.default = InitializeCart;
//# sourceMappingURL=InitializeCart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/cart-initializer/CartInit/InitializeCart.js
// module id = 1728
// module chunks = 8